import { COIN, CURRENCY_POSITION } from "constants";
/**
 * @param {number} value - The numeric value to format.
 * @returns {string} - The number formatted with two decimals and the currency symbol.
 * @throws {Error} - If the value is not a valid number.
 */
/**
 * Formatea un número al estilo español: . para miles, , para decimales
 * Garantiza el separador de miles desde 1.000 (compatible con todos los navegadores)
 */
function formatNumberSpanish(value) {
  const [intPart, decPart = '00'] = value.toFixed(2).split('.');
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withThousands},${decPart}`;
}

export function formatCurrency(value) {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
  const formattedValue = formatNumberSpanish(safeValue);
  return CURRENCY_POSITION === 'left'
    ? `${COIN} ${formattedValue}`
    : `${formattedValue} ${COIN}`;
}
